function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { NOTIFIER_HIDE, NOTIFIER_SHOW } from 'components/notifier/constants';
var stateDefault = {
  items: {}
};

var reducerNotifier = function reducerNotifier() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : stateDefault;
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (action.type) {
    case NOTIFIER_SHOW:
      {
        var payload = action.payload;
        return _objectSpread(_objectSpread({}, state), {}, {
          items: _objectSpread(_objectSpread({}, state.items), {}, _defineProperty({}, payload.item.id, _objectSpread(_objectSpread({}, payload.item), {}, {
            isVisible: true
          })))
        });
      }

    case NOTIFIER_HIDE:
      {
        var _payload = action.payload;

        var items = _objectSpread({}, state.items);

        if (_payload.force) {
          delete items[_payload.id];
        } else {
          items[_payload.id].isVisible = false;
        }

        return _objectSpread(_objectSpread({}, state), {}, {
          items: items
        });
      }

    default:
      return state;
  }
};

export { reducerNotifier };